import React from "react";

export default (props) => (
  <section className="content">
    <div className="row">
      <div className="col-12">
        <div className="card card-secondary">
          {props.children}
        </div>
      </div>
    </div>
  </section>
);
